import { Component, OnInit, ElementRef, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import * as utils from '../common/utils';
import * as units from '../common/units';
import * as enums from '../common/enums';
import * as settings from '../common/settings';
import { ZIndexMngr } from '../common/ZIndexMngr';
import { mainMapMngr } from '../asp/MapMngr';
import { Point } from '../common/Point';
import { TempDrawingsPool, TempDrawingDataType, TempDrawingObject } from '../asp/temp-drawings';
import { CrdtComponent } from '../common/crdt/crdt.component';
import { Animations } from '@core_n/Animations';

@Component({
  templateUrl: './jump-to.component.html',
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class JumpToComponent extends ZIndexMngr implements OnInit, OnDestroy, AfterViewInit {

  static readonly DIALOG_ID = 'jump-to';

  tempMarker: TempDrawingObject = null;

  @ViewChild('crdt', { static: true }) private crdt: CrdtComponent;

  constructor(public dialogRef: MatDialogRef<JumpToComponent>,
              private fb: FormBuilder,
              elementRef: ElementRef) {
    super(elementRef);
    mainMapMngr.activateMapEventsTool(this.onMapEvent.bind(this), [NeWMI.Map.Enums.EMapEvents.MouseDown]);
  }

  static createDialogConfig(top: number, left: number) {
    return utils.createDialogConfig(false, false, JumpToComponent.DIALOG_ID,
      { top: `${top + 10}px`, left: `${left + 10}px` });
  }

  ngOnInit() {
    let extent = mainMapMngr.getMapExtent();
    this.crdt.writeForm({ x: extent.xCenter, y: extent.yCenter });
    this.dialogRaise();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  ngOnDestroy(): void {
    this.deleteTempMarker();
    this.dialogClosed();
    mainMapMngr.activateDefaultTool();
  }

  onCenter() {
    let coord = this.crdt.readForm();
    if (coord) {
      mainMapMngr.setMapCenter(coord);
      if (this.tempMarker)
        this.createOrUpdateTempMarker(coord);
    }
  }

  onView() {
    if (this.tempMarker) {
      this.deleteTempMarker();
    }
    else {
      let coord = this.crdt.readForm();
      if (coord)
        this.createOrUpdateTempMarker(coord);
    }
  }

  onSubmit() {
    if (this.tempMarker) {
      let coord = this.crdt.readForm();
      if (coord)
        this.createOrUpdateTempMarker(coord);
    }
  }

  private createOrUpdateTempMarker(coord: Point) {
    let geom = new NeWMI.Geometry.Point(coord);
    if (this.tempMarker)
      this.tempMarker.updateGeometry(geom);
    else
      this.tempMarker = TempDrawingsPool.getSelf().createTempDrawing(TempDrawingDataType.Symbol, geom, { value: 'm' });
  }

  private deleteTempMarker() {
    if (this.tempMarker) {
      TempDrawingsPool.getSelf().deleteObject(this.tempMarker);
      this.tempMarker = null;
    }
  }

  private onMapEvent(evt: NeWMI.Map.Events.MouseEvents) {
    let coord = { x: evt.mapPoint.x, y: evt.mapPoint.y };
    this.crdt.writeForm(coord);
    if (this.tempMarker) {
      this.createOrUpdateTempMarker(coord);
    }
  }

}
